import _ from "lodash";

import { colors } from "theme/palette";

import Box from "components/Box";
import Stack from "components/Stack";
import Text from "components/Text";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { ISignatureCustomField } from "entities/MemoTemplate/sdk";

export interface IMemoSignatureSection {
  sectionName: string;
  roleName?: string;
  customFields?: Array<ISignatureCustomField>;
}

const PrintableMemoSignatureSection = ({
  roleName,
  sectionName,
  customFields,
}: IMemoSignatureSection) => (
  <Box sx={{ breakInside: "avoid" }}>
    <SectionHeader label={sectionName} />
    <SectionContent>
      {!_.isUndefined(roleName) && (
        <Text variant="label" fontWeight={500} marginBottom={0.8}>
          {roleName}
        </Text>
      )}
      <Stack direction="row" gap={5}>
        <Box border={1} width="420px" height="80px">
          <Text sx={{ color: colors.white, fontSize: 0.1 }}>
            This is a signature field for {roleName}
          </Text>
        </Box>

        <Stack direction="column" gap={2}>
          {customFields?.map((customField, index) => (
            <Stack>
              <Text variant="text3" color={colors.gray80} key={index}>
                {customField.name}
              </Text>
              <div style={{ height: "16px" }} />
            </Stack>
          ))}
        </Stack>
      </Stack>
    </SectionContent>
  </Box>
);

export default PrintableMemoSignatureSection;
